






















































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { financeContributeList } from '@/api/financeContribute';

import { hasPermission } from '@/utils/utils';
import moment from 'moment';
import { mapGetters } from 'vuex';
import {queryInvestFundList} from "@/api/document";
import downloadStreamFile from '@/assets/js/downloadStreamFile';




@Component({ computed: { ...mapGetters(['userInfo'])}})
class FinanceProjectContribution extends Vue {
  userInfo: any;
  filterNow: number = 0;
  columns: any[] = [];
  data: any[] = [];
  keyword: string = '';
  investFundNameKeyword: any[] = [] ;
  total: number = 0;
  pageSize: number = 10;
  loading: boolean = false;
  listInvestFundName: any[] =[];
  exportLoading: boolean = false;

  created() {
    this.getList(1);
    this.fetchOptions();

  }



  async getList(page) {
    try {
      this.data = [];
      let res = await financeContributeList(
        { page: page, 
          pageSize: this.pageSize,  
          companyName: this.keyword ,
          searchInvestFundIds: this.investFundNameKeyword.join(',')
        });
      if (res.code === 200) {
        let list = res.data.list || [];
        this.total = res.data.total;
        this.getData(list);
        this.getColumns();
      }
    } catch (err) {
      console.log(err);
    }
  }

  getData(list) {
    list.forEach(company => {
      if(company.deals){
        let companyRow = 0;
        company.deals.forEach((e,index) =>{
          if(index===0){
            console.log("项目：",company.companyName);
          }
          if(e.contributorList){
            companyRow+=e.contributorList.length;
          }else{
            companyRow++;
          }
        });
        console.log('companyRow=',companyRow);

        company.deals.forEach((e, indexDeal) =>{
          if(company.companyName === '渴望'){
            console.log("索引：",indexDeal);
          }

          if (e.contributorList) {
            e.contributorList.forEach(_ => {});
            e.contributorList.forEach((item, index) => {
              this.data.push({
                // ...company,
                companyId: company.companyId,
                companyName: company.companyName,
                roundName:e.roundName,
                deliveryDate:e.deliveryDate,
                dlName:e.dlName,
                investFundName: e.investFundName,
                contributeId: e.id,
                id: item.id,
                // time: moment(e.joinTime).format('YYYY-MM') || '',
                contributor: item.contributor,
                credit:item.credit,
                readme:item.readme,
                // records: item.records,
                companyRowSpan : indexDeal === 0 && index === 0 ? companyRow: 0,
                dealRowSpan: index === 0 ? e.contributorList.length : 0
              });
            });
          } else {
            this.data.push({
              // ...company,
              companyId: company.companyId,
              companyName: company.companyName,
              contributeId: e.id,
              roundName:e.roundName,
              deliveryDate:e.deliveryDate,
              dlName:e.dlName,
              investFundName: e.investFundName,
              companyRowSpan : indexDeal === 0 ? companyRow  : 0,
              // time: moment(e.joinTime).format('YYYY-MM') || '',
              dealRowSpan: 1
            });
          }
        });
      } else {
        this.data.push({
          ...company,
          companyRowSpan: 1,
          dealRowSpan: 1
        });
      }


    }


    );
    console.log(this.data);
  }



  getColumns() {
    this.columns = [
      {
        title: '项目名称',
        dataIndex: 'companyName',
        key: 'companyName',
        width: '5%',
        customRender: (value, row, index) => {
          const obj = {
            children: value,
            attrs: {}
          };
          if (row.companyRowSpan === 0) {
            obj.attrs['rowSpan'] = 0;
          } else {
            obj.attrs['rowSpan'] = row.companyRowSpan;
          }
          return obj;
        }
      },
      {
        title: '轮次',
        dataIndex: 'roundName',
        key: 'roundName',
        width: '8%',
        customRender: (value, row, index) => {
          const obj = {
            children: value + '轮',
            attrs: {}
          };
          if (row.dealRowSpan === 0) {
            obj.attrs['rowSpan'] = 0;
          } else {
            obj.attrs['rowSpan'] = row.dealRowSpan;
          }
          return obj;
        }
      },
      {
        title: '所属基金',
        dataIndex: 'investFundName',
        key: 'investFundName',
        width: '10%',
        align: 'center',
        customRender: (value, row, index) => {
          const obj = {
            children: value ,
            attrs: {}
          };
          if (row.dealRowSpan === 0) {
            obj.attrs['rowSpan'] = 0;
          } else {
            obj.attrs['rowSpan'] = row.dealRowSpan;
          }
          return obj;
        }
      },
      {
        title: 'DL',
        dataIndex: 'dlName',
        key: 'dlName',
        // width: '10%',
        width: '8%',
        align: 'center',  // 设置列内容居中对齐
        customRender: (value, row, index) => {
          const obj = {
            children: value,
            attrs: {}
          };
          if (value.dealRowSpan === 0) {
            obj.attrs['rowSpan'] = 0;
          } else {
            obj.attrs['rowSpan'] = row.dealRowSpan;
          }
          return obj;
        }
      },
      {
        title: '交割时间',
        dataIndex: 'deliveryDate',
        key: 'deliveryDate',
        width: '8%',
        align: 'center',
        customRender: (value, row, index) => {
          const obj = {
            children: value,
            attrs: {}
          };
          if (row.dealRowSpan === 0) {
            obj.attrs['rowSpan'] = 0;
          } else {
            obj.attrs['rowSpan'] = row.dealRowSpan;
          }
          return obj;
        }
      },
      {
        title: '贡献者',
        dataIndex: 'contributor',
        key: 'contributor',
        width: '8%',
        align: 'center',  // 设置列内容居中对齐
        scopedSlots: {
          customRender: 'contributor'
        }
      },
      {
        title: '贡献者描述',
        dataIndex: 'readme',
        key: 'readme',
        width: '30%',
        align: 'center',  // 设置列内容居中对齐
        customRender: (value, row, index) => {
          const obj = {
            children: value,
            attrs: {}
          };
          // obj.attrs['colSpan'] = 0;
          return obj;
        }
      },
      {
        title: '分配credit',
        dataIndex: 'credit',
        key : 'credit',
        width: '10%',
        align: 'center',  // 设置列内容居中对齐
        customRender: (value, row, index) => {
          const obj = {
            children: (value !== null && value !== undefined) ? (value === 0 ? '0%' : value + '%') : '',  // 处理 0 和空值
            attrs: {}
          };
          // obj.attrs['colSpan'] = 0;
          return obj;
        }
      }

    ];
  }

  onChange(page, pageSize) {
    this.getList(page);
  }



  filterChange(key) {
    this.filterNow = key;
    this.getList(1);
  }

  handleSearch() {
    this.getList(1);
  }

  exportFile() {
    try {
      this.exportLoading = true;
      let date = moment(new Date()).format('YYYYMMDD');
      let data = { companyName: this.keyword,searchInvestFundIds: this.investFundNameKeyword.join(',') };
      downloadStreamFile('financeContribute/export', data, `credit_download_${date}`).then(() => {
        this.exportLoading = false;
      });

    } catch (error) {
      this.$message.error('导出失败');
      this.exportLoading = false;
    }
  }

  async fetchOptions() {
    try {
      let res = await queryInvestFundList('');
      if (res.code === 200) {
        this.listInvestFundName = res.data;

      }
    } catch (err) {
      console.log(err);
    }

  }

  dropdownVisibleChange(open) {
    open && this.fetchInvestFundName('');
  }

  fetchInvestFundName(value){
    queryInvestFundList(value).then(res => {
      if (res.code === 200) {
        this.listInvestFundName = res.data;
      }
    });
  }


}
export default FinanceProjectContribution;
